module.exports = __webpack_public_path__ + "fonts/fa-regular-400.c20b5b73.woff2";